import { FC, ReactNode } from "react";
import { useRouter } from "next/router";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import localizedFormat from "dayjs/plugin/localizedFormat";
import localeData from "dayjs/plugin/localeData";

import "dayjs/locale/tr";
import "dayjs/locale/en";

interface IDayJsProviderProps {
  children: ReactNode;
}

const DayJsProvider: FC<IDayJsProviderProps> = ({ children }): ReactNode => {
  const router = useRouter();

  dayjs.locale(router.locale);
  dayjs.extend(timezone);
  dayjs.extend(localizedFormat);
  dayjs.extend(localeData);

  dayjs.tz.setDefault(dayjs.tz.guess());

  return children;
};

export default DayJsProvider;
